const SERVICES = [
  {
    title: "AI inventory and risk map",
    text: "Which tools you use, where the data goes, and what the AI Act requires of each one.",
    items: ["Tool-by-tool inventory", "AI Act role and risk classification", "Readiness memo you can hand to a board or a buyer"],
  },
  {
    title: "Policies and documentation",
    text: "Written, aligned and signed. Your team just uses them.",
    items: ["Internal AI policy and acceptable-use rules", "Vendor contracts and data terms", "Records, notices and the evidence you must be able to show"],
  },
  {
    title: "Verified tools in operation",
    text: "Tools we have tested ourselves, introduced into your finance, HR and sales workflows.",
    items: ["Selection and legal pre-check", "Set-up with your team", "Review of every new feature before it goes live"],
  },
  {
    title: "Officer on call",
    text: "A named person your team can ask, all year.",
    items: ["AI literacy training (Art. 4 AI Act)", "Regular check-ins and regulatory watch", "EU representative mandate for non-EU companies (Art. 22 AI Act)"],
  },
];

export const Services = () => (
  <section className="section section--cream" aria-labelledby="four-title" data-testid="services-section">
    <div className="container">
      <div className="stack section-head" data-reveal>
        <p className="eyebrow">What your AI officer does</p>
        <h2 id="four-title" className="title">Four things. One licence. One team that answers.</h2>
        <p className="lead">Everything a company using AI needs to have in order, done for you and kept current.</p>
      </div>
      <div className="services section-body" data-reveal>
        {SERVICES.map((s, i) => (
          <article className="service" key={s.title} data-testid={`service-card-${i + 1}`}>
            <p className="service__num">{String(i + 1).padStart(2, "0")}</p>
            <h3 className="service__title">{s.title}</h3>
            <p className="service__text">{s.text}</p>
            <ul className="service__list">
              {s.items.map((it) => <li key={it}>{it}</li>)}
            </ul>
          </article>
        ))}
      </div>
    </div>
  </section>
);
